/**
* For all marketo embed handling
*/

/**
* @function marketoSetup Iterates through each field and puts a field specific modifier on its wrapper. https://developers.marketo.com/javascript-api/forms/api-reference/
* @param  {HTMLFormElement} form Form element for marketo
*/
function marketoSetup (form) {
    const fieldWrappers = [...form.querySelectorAll('.mktoFieldWrap')]
    const mktoFormRows = [...form.querySelectorAll('.mktoFormRow')]

    fieldWrappers.forEach(fieldWrapper => {
        const input = fieldWrapper.querySelector('input')
        const textarea = fieldWrapper.querySelector('textarea')
        const select = fieldWrapper.querySelector('select')

        if (input) {
            fieldWrapper.classList.add(`-${input.type}`)
        }

        if (textarea) {
            fieldWrapper.classList.add('-textarea')
        }

        if (select) {
            fieldWrapper.classList.add('-select')
        }
    })

    mktoFormRows.forEach(mktoFormRow => {
        const namedEls = [...mktoFormRow.querySelectorAll('[name]')]

        if (namedEls.length) {
            namedEls.forEach(namedEl => {
                mktoFormRow.classList.add(`-${namedEl.name}`)
            })
        } else {
            mktoFormRow.classList.add('-noField')
        }
    })
}


/**
* @function formRender Handles dynamic manipulation of form elements and inputs
* @param  {Object} form Marketo Form Object. https://developers.marketo.com/javascript-api/forms/api-reference/
*/
function formRender (form) {
    const [formEl] = form.getFormElem()
    setTimeout(() => {
        marketoSetup(formEl)
    }, 200)

    formEl.modal = this
    formEl.id = `form${form.getId()}`
    if ('mktoPreFill' in window) {
        form.setValues(window.mktoPreFill)
    }
}


if (typeof MktoForms2 !== 'undefined') {
    const mktoForms = MktoForms2.allForms()

    mktoForms.forEach(form => {
        const [formEl] = form.getFormElem()
        const formId = form.getId()
        while (formEl.firstChild) formEl.removeChild(formEl.lastChild)

        MktoForms2.loadForm('//app-abc.marketo.com', '770-RCD-578', formId)
    }) // I'm sorry

    MktoForms2.onFormRender(formRender)
}

export { marketoSetup, formRender }
